<template>
  <div>
    <div v-if="object">
      <b-tabs nav-class="sub-menu"
              content-class="pt-4"
              class="w-100"
              @activate-tab="tabSelected">
        <b-tab :active="lind === 0"
               v-for="(l, lind) in langs"
               :key="`${l}`"
               :title="titles[l]">
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script setup>
import { useStore } from "vuex"
import {onMounted} from "vue"

const langs = [
  'general',
  'ru',
  'en',
  'uk',
  'uz',
  'az',
  'kz',
  'kg'
]
const titles = {
  general: 'Общая',
  ru: 'Рус',
  en: 'Eng',
  uk: 'Укр',
  uz: "O'zb",
  az: 'Azər',
  kz: 'Қаз',
  kg: 'Кыр',
}

defineProps({
  object: {
    type: Object
  },
})

const store = useStore()

onMounted(() => {
  store.commit('setFormTabActive', langs[0])
})

const tabSelected = (tab) => {
  store.commit('setFormTabActive', langs[tab])
}
</script>
